  <template>
	<div id="home" style="width: 100%">
		<div v-if="show_loading" class="loding_slider">
			<mu-circular-progress class="demo-circular-progress" color="grey500" :stroke-width="4" :size="90"></mu-circular-progress>
		</div>
		<div v-else>
			<div v-if="lang=='es'">
				<Slider :imagesland="landscape" :imagesport="portrait" :link="true" :device="getDevice"></Slider>
			</div>
			<div v-else>
				<Slider :imagesland="landscape_en" :imagesport="portrait_en" :link="true" :device="getDevice"></Slider>
			</div>
		</div>
	</div>
</template>
<script>
import _GlobalHelper from '@/store/helpers/global'
import _VersionHelper from '@/store/helpers/common/version'
import _SliderHelper from '@/store/helpers/common/slider'
// COMPONENTS
import Slider from '@/components/Slider/Slider'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
	name: 'slider',
	props: {
		page: String
	},
	components: {
		Slider: Slider
	},
	data() {
		return {
			landscape: null,
			portrait: null,
			landscape_en: null,
			portrait_en: null,
			version: null,
			attempt_version: 0,
			attempt_slider : 0,
			message: [],
			show_loading: false
		}
	},
	computed: {
		getDevice() {
			var user_agent = navigator.userAgent || navigator.vendor || window.opera
			var sys = navigator.platform
			if (/windows phone/i.test(user_agent)) {
				return 'Windows'
			}
			else if (/android/i.test(user_agent)) {
				return 'Android'
			}
			else if (/iPad|iPhone|iPod/.test(user_agent) && !window.MSStream) {
				return 'iOS'
			}
			else if (sys.indexOf('Win') == 0) {
				return 'Windows'
			}
			else if (sys.indexOf('Mac') == 0) {
				return 'Mac'
			}
			else if (sys.indexOf('X11') == 0 || (sys.indexOf('Linux') == 0)) {
				return 'Linux'
			}
			else {
				return 'none'
			}
		},
		loading: {
			set(data) {
				this.set_loading(data)
			},
			get() {
				
			}
		},
		...mapGetters({
			lang: _GlobalHelper.getters.language
		}),
	},
	methods: {
		...mapActions({
			select: _VersionHelper.actions.select,
			list: _SliderHelper.actions.list,
		}),
		...mapMutations({
            setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
			set_loading: _GlobalHelper.mutations.loading,
        }),
		async getVersion(){
			await this.select({
				project_id: (this.page == 'home') ? this.$config.project_id : (this.page == "internet") ? this.$config.internet_id : this.$config.promotion_id,
				last_active: true
			}).then(({ success, data, error }) => {
				if (!success && error == undefined) {
					if(this.attempt_version < 3){
						this.attempt_version = this.attempt_version +1;
						this.getVersion()
					}
					else {
						this.show_loading = true
						this.loading = { show: false, message: null }
					}
				}
				if (!success && error.length > 0) {
					if(this.attempt_version < 3){
						this.attempt_version = this.attempt_version +1;
						this.getVersion()
					}
					else {
						this.show_loading = true
						this.loading = { show: false, message: null }
					}
				}
				if (success && data) { 
					this.version = data.version
					if(this.attempt_version > 0){
						this.getSlider()
					}
				}
			});
		},
		async getSlider(){
			await this.list({
				project_id: this.version.project_id,
				version: this.version.version,
				most_origins: true,
				only_active: true
			}).then(({ success, data, error }) => {
				if (!success && error == undefined) {
					if(this.attempt_slider < 3){
						this.attempt_slider = this.attempt_slider +1;
						this.getSlider()
					}
					else {
						this.show_loading = true
						this.loading = { show: false, message: null }
					}
				}
				if (!success && error.length > 0) {
					if(this.attempt_slider < 3){
						this.attempt_slider = this.attempt_slider +1;
						this.getSlider()
					}
					else {
						this.show_loading = true
						this.loading = { show: false, message: null }
					}
				}
				if (success && data) { 
					this.loading = { show: false, message: null }
					for(let [key,value] of Object.entries(data.list)) {
						switch(key) {
							case "PORTRAIT - ES":
								this.portrait = value
								break;
							case "LANDSCAPE - ES":
								this.landscape = value
								break;
							case "PORTRAIT - EN":
								this.portrait_en = value
								break;
							case "LANDSCAPE - EN":
								this.landscape_en = value
								break; 
						}
					}
				}
			})
		}
	},
	async created() {
		this.message = []
		//this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>` }
		await this.getVersion()
		if(this.version != null) {
			await this.getSlider()
		}
		// this.loading = { show: false, message: null }
	}
}
</script>
<style lang="scss">
#home {
	.container-fluid {
		.row {
			h4 {
				width: 100%;
				text-align: center;
			}
		}
	}
}
.loding_slider{
	height: 500px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>